import { useState } from 'react';
import fleetApi from '../../services/api.service';

const usePostReorderSteps = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(null);
  const [data, setData] = useState(null);

  const reorderSteps = async (stepIdSource, stepIdTarget, tourId) => {
    resetStates();
    try {
      setIsLoading(true);
      const response = await fleetApi.post(`/tours-planning/steps/reorder`, {
        step_id_source: stepIdSource,
        step_id_target: stepIdTarget,
        tour_id: tourId,
      });

      if (response.status === 200) {
        setIsSuccess(true);
        setData(response.data);
        return response.data;
      } else {
        throw new Error(response.data?.message || 'Une erreur est survenue.');
      }
    } catch (error) {
      setIsSuccess(false);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const resetStates = () => {
    setIsSuccess(false);
    setIsLoading(false);
    setData(null);
  };

  return {
    isLoading,
    isSuccess,
    data,
    reorderSteps,
  };
};

export default usePostReorderSteps;

